import { makeLogger } from '../../../logger/logger';
import { authenticationHeaders} from '../../guided/subcomponents/utils';
import communityWidgetStore from './exchange-community.store';

const { err } = makeLogger({
  pathToCurrentFile: 'components/widgets/exchange-community/exchange-community-actions.tsx',
  loggersList: ['err']
});

type Headers = Record<string, string>;

export const getValues = async function (data, successCallback) {

    const {term, mockedData, apiEndpoint, apigeeAuth, apigeeTokenUrl} = data;

    const createUrl = (endpoint: string) => {
        try {
          const url = new URL(endpoint);
          url.searchParams.append('ui-component', 'widget-exchange-community');
          return url.href;
        } catch (e) {
          err(`unable to create url from  ${endpoint}`);
          return '';
        }
    };

    const url = createUrl(apiEndpoint);


    if (communityWidgetStore.state.term == term){
      data.mockedData = communityWidgetStore.state.answers;
      return successCallback(data.mockedData);
    } else {
      communityWidgetStore.state.term = term;
    }

    const authHeaders = await authenticationHeaders({
      apigeeBasicAuth: apigeeAuth,
      tokenUrl: apigeeTokenUrl,
    });

    const headers: Headers = {
      'Content-type': 'application/json; charset=utf-8',
      ...authHeaders
    };

    const requestBody = {
      searcher: 'se/support/community',
      country: 'ww',
      language: 'en',
      term: term,
      forceTerm: false,
      pagination: {
        limit: 4,
        offset: 0
      }
    };

    const request = new Request(url, {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: headers,
    });

    if (mockedData?.length) {
      return successCallback(mockedData);
    }

    return fetch(request, successCallback)
      .then(response => response.json())
      .then(json => {
          communityWidgetStore.state.answers = json.documents;
          successCallback(communityWidgetStore.state.answers);
      })
      .catch((e) => {
          err('Failed to fetch data from Exchange API', e, {request: request});
      });
};
